const sixRegional = ['西北地区', '华北地区', '中南地区', '华东地区', '东北地区', '西南地区'] // 六大地区
const gansuProvince = ['兰州', '嘉峪关', '金昌', '酒泉', '张掖', '武威', '白银', '天水', '平凉', '庆阳', '定西', '陇南', '甘南', '临夏'] // 甘肃省
const tooltip = {
    axisPointer: {
        type: 'line',
        lineStyle: {
            type: 'solid'
        }
    },
    textStyle: {
        color: '#fff',
        align: 'left'
    },
    backgroundColor: 'rgba(8,25,57,0.9)',
    borderWidth: 1,
    borderColor: '#2195d9'
}
export default { // 输出
    tooltip,
    sixRegional,
    gansuProvince
}



// WEBPACK FOOTER //
// ./src/utils/publicObj.js